export const SET_SETTINGS = "@@app/SET_SETTINGS";